import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from '@angular/forms';
import { Store } from 'src/app/core/store/store';
import { FeedbackService } from '../../services/feedback.service';
import { User } from '../../models/user.model';
// import { FeedbackService } from '../services/feedback.service';
// import { config } from 'src/app/config';
// import { Store } from 'store';
// import { User } from 'src/app/models/user.model';
// declare var amplitude;

@Component({
  selector: 'app-report-feedback',
  templateUrl: './report-feedback.component.html',
  styleUrls: ['./report-feedback.component.css']
})
export class ReportFeedbackComponent implements OnInit {

  @Input() data;
  @Input() updateData;
  mode = 'new';
  text;
  user;
  @Output() feedbackResponse = new EventEmitter<any>();

  constructor(public activeModal: NgbActiveModal, private store: Store, private fb: FormBuilder, private feedbackService: FeedbackService) { }

  ngOnInit() {
    this.store.select<User>('user').subscribe(user => {
      if (user) {
        this.user = user;
      }
    });
    console.log(this.data);
    if (this.updateData) {
      this.mode = 'old';
    }
  }

  close() {
    this.activeModal.close();
  }

  submitFeedback() {
    let payload = {
      courseId: this.data.courseId,
      courseName: this.data.courseName,
    }
    payload['exerciseId'] = this.data.exerciseId;
    payload['exerciseName'] = this.data.exerciseName;
    payload['questionId'] = this.data.questionId;
    payload['isFeedback'] = true;
    if (this.mode === 'new') {
      payload['comment'] = [];
    } else {
      payload['comment'] = this.updateData.comment;
    }
    payload['comment'].push(this.text);
    if (this.mode == 'new') {
      this.feedbackService.saveFeedback(payload).subscribe((res) => {
        this.feedbackResponse.emit(res['data']);
        // this.amplitudeFeedbackReported();
        this.activeModal.dismiss();
      });
    } else {
      this.feedbackService.updateFeedback(this.updateData._id, payload).subscribe((res) => {
        this.feedbackResponse.emit(res['data']);
        // this.amplitudeFeedbackReported();
        this.activeModal.dismiss();
      });
    }
  }

  amplitudeFeedbackReported() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization, 'cohortName': (this.user['userGroup'] || '') });
    amplitude.getInstance().logEvent('Give Feedback On Question', { 'Course Name': this.data.courseName, 'Exercise Name': this.data.exerciseName, 'Question Number': this.data.questionNumber }); */
  }
}
